import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import axios from "axios";
import Swal from "sweetalert2";

export default function Strategy() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [planType, setPlanType] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    let type = searchParams.get("plan");
    if (!type) {
      setSearchParams({ plan: "gate_in" }, { replace: true });
      type = "gate_in";
    }
    setPlanType(type);
  }, []); 

  
  useEffect(() => {
    if (planType) {
      setSearchParams({ plan: planType }, { replace: true });
      fetchData();
    }
  }, [planType]);
  

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://ctas.live/backend/api/get/yard/planning?plan_type=${planType}`
      );
      setData(response.data.data);
    } catch (error) {
      console.error("Error fetching stacks:", error);
    } finally {
      setLoading(false);
    }
  };

  const deletePlan = async (dd) => {
    try {
      const response = await axios.post(
        `https://ctas.live/backend/api/delete/yard/planning?id=${dd.id}`
      );
      if (response?.data?.status === "success") {
        Swal.fire({
          icon: "success",
          text: "Successfully Deleted",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => fetchData());
      }
    } catch (error) {
      console.error("Error deleting plan:", error);
    }
  };

  return (
    <>
      {loading && (
        <div className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100" style={{ zIndex: 9999 }}>
          <div className="sk-chase sk-primary display-1">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="sk-chase-dot" />
            ))}
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <h3 className="text-primary">Yard Strategy</h3>
                  <Link to="/strategy/add" className="btn btn-primary">Add New Yard Plan</Link>
                </div>
                <div className="d-flex align-items-center gap-3 mb-2">
                  <button onClick={() => setPlanType('gate_in')} className={`btn btn-sm ${planType === "gate_in" ? 'btn-info' : 'btn-outline-info'}`}>Gate In Strategy</button>
                  <button onClick={() => setPlanType('rake_in')} className={`btn btn-sm ${planType === "rake_in" ? 'btn-info' : 'btn-outline-info'}`}>Rake In Strategy</button>
                  <button onClick={() => setPlanType('ewh_yard')} className={`btn btn-sm ${planType === "ewh_yard" ? 'btn-info' : 'btn-outline-info'}`}>Warehouse Strategy</button>
                  {/* <Link to="/warehouse_jobs?warehouse=Import" className="btn btn-outline-info btn-sm">Import Warehouse Strategy</Link>
                  <Link to="/warehouse_jobs?warehouse=Export" className="btn btn-outline-info btn-sm">Export Warehouse Strategy</Link> */}
                </div>
                <div className="card">
                  <div className="card-body px-1">
                    <div className="table-responsive text-nowrap">
                      <table className="table table-hover table-font table-striped">
                        <thead>
                          <tr className="table-primary">
                            <th>S.No.</th>
                            <th>Plan Type</th>
                            <th>Cntr Type</th>
                            <th>Cntr Size</th>
                            <th>HAZ</th>
                            <th>Stack Name</th>
                            <th>Rows</th>
                            <th>Location From</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((dd, key) => (
                            <tr key={dd.id}>
                              <td>{key + 1}</td>
                              <td>{dd.plan_type.toUpperCase()}</td>
                              <td>{dd.container_type}</td>
                              <td>{dd.container_size}</td>
                              <td>{dd.is_haz}</td>
                              <td>{dd.stack_name}</td>
                              <td>{dd.stack_rows}</td>
                              <td>{dd.location_from} - {dd.location_to}</td>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                <Link to={`/strategy/update/${dd.id}`} className="btn btn-sm btn-info"><i className="ri-edit-circle-line"></i></Link>
                                <button className="btn btn-sm btn-danger" onClick={() => deletePlan(dd)}><i className="ri-delete-bin-line"></i></button>

                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
